import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const StyledContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
